// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `#f4f4f7`,
	"blue300": `#7c53a5`,
	"blue50": `#eceaef`,
	"blue600": `#4b286d`,
	"bronze": `#cc8b54`,
	"focus": `#2681e1`,
	"gold": `#e9b725`,
	"green300": `#2b8000`,
	"green50": `#e9f2e6`,
	"green600": `#2b8000`,
	"neutral100": `#2c2e30`,
	"neutral15": `#e3e6e8`,
	"neutral30": `#e3e6e8`,
	"neutral45": `#b3b9be`,
	"neutral75": `#424547`,
	"platinum": `#b5b9c9`,
	"primary200": `#d8cbe5`,
	"primary300": `#7c53a5`,
	"primary50": `#f2eff4`,
	"primary600": `#4b286d`,
	"primary700": `#371e47`,
	"red300": `#c12335`,
	"red50": `#f9e8eb`,
	"red600": `#c12335`,
	"silver": `#c7c7c7`,
	"surface1": `#fff`,
	"surface2": `#fafafa`,
	"yellow300": `#ffe36e`,
	"yellow50": `#fff8db`,
	"yellow600": `#b85306`
};
export default ___CSS_LOADER_EXPORT___;
